<template>
  <div class="app-container">
    <el-tabs v-model="activeName" >
      <el-tab-pane label="排号列表" name="one" style="">
        <paihaoliebiao v-if="activeName=='one'"></paihaoliebiao>
      </el-tab-pane>
      <el-tab-pane label="操作记录" name="two">
        <caozuojilu v-if="activeName=='two'"></caozuojilu>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import paihaoliebiao from '@/views/vgs-driver2.0/ziyouyunli/shiftScheduling/paihaoliebiao.vue'
import caozuojilu from '@/views/vgs-driver2.0/ziyouyunli/shiftScheduling/caozuojilu.vue'
export default {
  components: {
    paihaoliebiao,
    caozuojilu
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {

  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}

</style>
